import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Play, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { errMsg } from "@/lib/api";

const SLOT = { morning: "Morning", afternoon: "Afternoon", night: "Night" };

export function FirstCallPreview({ api, sid, body }) {
  const [p, setP] = useState(null);
  const [busy, setBusy] = useState("");
  const load = async () => {
    setBusy("text");
    try { setP((await api.post(`/subs/${sid}/preview-call`, body)).data); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(""); }
  };
  const play = async () => {
    setBusy("audio");
    try {
      const r = await api.post(`/subs/${sid}/preview-call?audio=true`, body, { responseType: "blob" });
      const a = new Audio(URL.createObjectURL(r.data)); a.onended = () => setBusy(""); a.onerror = () => setBusy(""); a.onpause = () => setBusy(""); await a.play();
      if (!p) { load(); }
    } catch (e) { toast.error("Could not play the call"); setBusy(""); }
  };
  return (
    <div className="grid gap-2 rounded-2xl border border-[var(--lav-3)] bg-[var(--lav)]/40 p-3" data-testid="first-call-preview">
      <div className="flex flex-wrap items-center gap-2">
        <p className="mr-auto text-sm font-bold">First call — hear it before approving</p>
        <Button type="button" size="sm" variant="outline" disabled={!!busy} onClick={load} data-testid="first-call-show-btn">{busy === "text" ? <Loader2 size={14} className="animate-spin" /> : <RefreshCw size={14} />} {p ? "Refresh" : "Show script"}</Button>
        <Button type="button" size="sm" disabled={!!busy} onClick={play} className="bg-[var(--violet)]" data-testid="first-call-play-btn">{busy === "audio" ? <Loader2 size={14} className="animate-spin" /> : <Play size={14} />} Play (phone quality)</Button>
      </div>
      {p && <p className="text-xs text-muted-foreground" data-testid="first-call-when">{SLOT[p.slot]} call · {p.date} · {p.time}</p>}
      {p && <p className="font-te text-sm leading-relaxed" data-testid="first-call-text">{p.text}</p>}
    </div>
  );
}
